import { render, staticRenderFns } from "./insertCategory.vue?vue&type=template&id=2cf5df02"
import script from "./insertCategory.vue?vue&type=script&lang=js"
export * from "./insertCategory.vue?vue&type=script&lang=js"
import style0 from "./insertCategory.vue?vue&type=style&index=0&id=2cf5df02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports